<ng-container
  *ngIf="
    showNewProfileSelector;
    then newProfileSelector;
    else oldProfileSelector
  "
></ng-container>
<ng-template #newProfileSelector>
  <div
    #triggerElement1
    (keydown.enter)="toggleNewProfileSelectorModal()"
    *ngIf="displayBusinessOnInitialLoad"
    class="account-type"
    tabindex="0"
  >
    <div class="pl-0 account-details">
      <span
        (click)="toggleNewProfileSelectorModal()"
        *ngIf="alreadyLogged || isWarmState"
      >
        {{ displayTravelType }}
      </span>
      <span
        (click)="toggleNewProfileSelectorModal()"
        *ngIf="alreadyLogged || isWarmState"
        class="open-flyout"
      >
        <img
          alt="open flyout"
          class="toggle-flyout"
          src="/content/dam/delta-applications/header/clear.gif"
        />
      </span>
    </div>
  </div>
</ng-template>
<ng-template #oldProfileSelector>
  <div
    #triggerElement1
    (keydown)="openUserDetailsOnEnter($event)"
    *ngIf="displayBusinessOnInitialLoad"
    class="account-type"
    tabindex="0"
  >
    <div class="pl-0 account-details">
      <!--<span *ngIf="hasBusinessOnly && !alreadyLogged">{{(switchingAccountService.accountType).toUpperCase()}}</span>-->
      <span
        (click)="openUserDetails($event)"
        *ngIf="alreadyLogged || isWarmState"
      >
        {{ displayTravelType }}
      </span>
      <span
        (click)="openUserDetails($event)"
        *ngIf="alreadyLogged || isWarmState"
        class="open-flyout"
      >
        <img
          alt="open flyout"
          class="toggle-flyout"
          src="/content/dam/delta-applications/header/clear.gif"
        />
      </span>
    </div>
  </div>
</ng-template>
